import apiClient from './api/client'
import type { Conversation, ConversationDetail, Message } from '../types/messaging'
import type { PaginatedResponse } from '../types'

export const messagingService = {
  // Get all conversations
  async getConversations(): Promise<PaginatedResponse<Conversation>> {
    const { data } = await apiClient.get('/messages/conversations/')
    return data
  },

  // Get a single conversation with messages
  async getConversation(id: string): Promise<ConversationDetail> {
    const { data } = await apiClient.get(`/messages/conversations/${id}/`)
    return data
  },

  // Send a message
  async sendMessage(conversationId: string, content: string): Promise<Message> {
    const { data } = await apiClient.post(`/messages/conversations/${conversationId}/messages/`, {
      content,
    })
    return data
  },

  // Mark conversation as read
  async markRead(conversationId: string): Promise<{ marked_read: number }> {
    const { data } = await apiClient.post(`/messages/conversations/${conversationId}/mark_read/`)
    return data
  },

  // Get total unread count
  async getUnreadCount(): Promise<{ unread_count: number }> {
    const { data } = await apiClient.get('/messages/conversations/unread_count/')
    return data
  },
}

export default messagingService
